// extracted by mini-css-extract-plugin
export default {"icon":"common-webview-NativeOverflowUI__icon--2DZg2"};